import { type PropsWithChildren } from "react";

import Await from "../async/Await";

export default function Page(props: PropsWithChildren) {
    const { children } = props;
    return <Await>{children}</Await>;
}
